import { trendingTicker } from "@/mocks/guagua";

export default function Ticker() {
  const doubled = [...trendingTicker, ...trendingTicker];
  return (
    <div className="w-full bg-foreground-950 text-background-50 overflow-hidden py-2.5">
      <div className="flex items-center">
        <div className="flex items-center gap-1.5 px-3 md:px-6 shrink-0 border-r border-background-700">
          <i className="ri-fire-fill text-primary-500"></i>
          <span className="text-xs font-semibold tracking-wide whitespace-nowrap">实时热瓜</span>
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex whitespace-nowrap animate-marquee w-max">
            {doubled.map((t, i) => (
              <span key={i} className="flex items-center text-sm text-background-100">
                <span className="px-5">{t}</span>
                <i className="ri-slice-fill text-primary-500/70 text-xs"></i>
              </span>
            ))}
          </div>
        </div>
        <div className="hidden sm:flex items-center gap-1.5 px-3 md:px-6 shrink-0 border-l border-background-700">
          <i className="ri-refresh-line animate-spin text-accent-400"></i>
          <span className="text-xs text-background-300 whitespace-nowrap">刚刚更新</span>
        </div>
      </div>
    </div>
  );
}